const PREFIX = 'aiciting-web-'

const storeStorage = {
  setItem(key, value) {
    if (value === undefined || value === null) return
    const raw = typeof value === 'string' ? value : JSON.stringify(value)
    localStorage.setItem(PREFIX + key, raw)
    // 兼容旧版 pinia 默认 key（无前缀）
    localStorage.setItem(key, raw)
  },
  getItem(key) {
    const value = localStorage.getItem(PREFIX + key) || localStorage.getItem(key)
    return value || null
  }
}

export default storeStorage
